import axios from '@axios'

const route = 'pricing'

export default {
  namespaced: true,
  state: {
    dialogMessagePayment: false,
    typeMessage: 'info',
    titleMessage: 'Pagamento',
    textMessage: '',
    titleMessage: '',
  },
  getters: {
    getDialogMessagePayment: state => state.dialogMessagePayment,
    getTypeMessage: state => state.typeMessage,
    getTitleMessage: state => state.titleMessage,
    getTextMessage: state => state.textMessage,
    getTitleMessage: state => state.titleMessage,
  },
  mutations: {
    setDialogMessagePayment(state, value) {
      state.dialogMessagePayment = value
    },
    setTypeMessage(state, value) {
      state.typeMessage = value
    },
    setTitleMessage(state, value) {
      state.titleMessage = value
    },
    setTextMessage(state, value) {
      state.textMessage = value
    },
    setTitleMessage(state, value) {
      state.titleMessage = value
    },
    clearPrincing(state) {
      state.dialogMessagePayment = false
      state.typeMessage = 'info'
      state.titleMessage = 'Pagamento'
      state.textMessage = ''
      state.titleMessage = ''
    },
  },
  actions: {
    getPlanTenant(context) {
      return axios.get('account/plan-tenant')
    },
  },
}
